export default {
    deleteTax: function ({commit},payload) {
        commit('DELETE_TAX',payload)
    },
    addTax: function ({commit},payload) {
        commit('ADD_TAX',payload)
        commit('UPDATE_SNACK',"success")
    },
    deleteProduct: function ({commit},payload) {
        commit('DELETE_PRODUCT',payload)
        commit('UPDATE_SNACK',"danger")
    },
    addProduct: function ({commit},payload) {
        commit('ADD_PRODUCT',payload)
        commit('UPDATE_SNACK',"success")
    },
    nextStep: function ({commit}) {
        commit('NEXT_STEP')
    },
    prevStep: function ({commit}) {
        commit('PREV_STEP')
    },
    toogleNavbarAction: function ({commit}) {
        commit('TOOGLE_NAVBAR_ACTIONS')
    },
    updateInvoice: function ({commit}, payload) {
        commit('SET_INVOICE', payload)
     },
     updateSnack: function ({commit}, payload) {
        commit('UPDATE_SNACK', payload)
     },
     updateModal: function ({commit}, payload) {
        commit('UPDATE_MODAL', payload)
     },
     setUser: function ({commit}, payload) {
        commit('SET_USER', payload)
        if(Object.keys(payload).length === 0){
            commit('UPDATE_AVATAR', {show : false, email : ""})
        }else{
            commit('UPDATE_AVATAR', {show : true, email : payload.user.email})
        }
     },
     toogleFetching: function ({commit}) {
        commit('TOOGLE_FETCHING')
    },
    toogleSidebar: function ({commit},payload) {
        commit('TOOGLE_SIDEBAR',payload)
    },
    updateSubTotal: function ({commit},payload) {
        commit('UPDATE_SUB_TOTAL',payload)
    },
    updateTotal: function ({commit},payload) {
        commit('UPDATE_TOTAL',payload)
    },
    initStepper: function ({commit}) {
        commit('INIT_STEPPER')
    },
    updateAvatar: function ({commit},payload) {
        commit('UPDATE_AVATAR',payload)
    },
    setUserInvoices: function ({commit}, payload) {
        commit('SET_USER_INVOICES',payload)
    },
    logout: function ({commit}) {
        commit('LOGOUT')
        commit('RESET_STATE_DEFAULT')
    },
    resetStateToDefault: function ({commit}){
        commit('RESET_STATE_DEFAULT')
    },
    setSaveButtonStatus: function ({commit}, payload) {
        commit('SET_SAVE_BUTTON_STATUS',payload)
    },
    setUserProfile: function ({commit}, payload) {
        commit('SET_USER_PROFILE',payload)
        commit('UPDATE_SNACK', "update")
    },
}